import { useState, memo, useEffect } from 'react'
import { Images } from '../../../../../assets/scripts/Images'
import BrandsModal from '../../../../modal/BrandsModal'

function ServiceItemCheckbox({ activeFilter, label, list, services, setServices }) {
  const [showBrands, setShowBrands] = useState(false)
  const [inputs, setInputs] = useState({})

  useEffect(() => {
    let currentList = services.filter((service) => service?.service_category === activeFilter)
    let queryParams = {}
    for (let item of currentList) {
      queryParams[item?.type] = item?.description
      if (item?.description === 'changed') {
        queryParams[`product${item?.type}`] = item?.['product']
        queryParams[`useful_km${item?.type}`] = item?.useful_km
      }
    }
    setInputs({
      ...inputs,
      ...queryParams,
    })
  }, [])

  const handleShowProduct = () => {
    setShowBrands(true)
  }

  const inputHandler = (e) => {
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value,
    })
    services.push({
      product: null,
      useful_km: null,
      type: label,
      description: e.target.value,
      service_category: activeFilter,
    })
    const key = 'type'
    const unique = [...new Map(services.map((item) => [item[key], item])).values()]
    setServices([...unique])
  }

  return (
    <>
      <div className={'flex flex-col mb-12'}>
        <h3 className={'text-blue text-lg font-medium mb-4 dark:text-amber-100'}>{label}</h3>
        <label
          className={'text-normal font-md flex item-center mb-4 cursor-pointer dark:text-gray-200'}
        >
          <input
            onChange={inputHandler}
            value={'changed'}
            checked={inputs?.[label] === 'changed'}
            className={'ml-2 w-5 h-5'}
            type="radio"
            name={label}
          />
          تعویض شد
        </label>
        {inputs[label] === 'changed' &&
          (label === 'روغن موتور' ||
            label === 'روغن گیربکس' ||
            label === 'لنت' ||
            label === 'ضدیخ' ||
            label === 'تسمه') && (
            <div
              className="bg-white dark:bg-slate-600 rounded-md py-2 px-4 w-fit mb-4 cursor-pointer"
              onClick={handleShowProduct}
            >
              <span className={'text-base text-normal dark:text-gray-200'}>
                {list?.find((elem) => elem.id === inputs?.[`product${label}`])
                  ? list?.find((elem) => elem.id === inputs?.[`product${label}`])?.name
                  : 'انتخاب مارک'}
              </span>
              <img src={Images.arrowDown} className={'inline-block pr-3'} alt="arrow down" />
            </div>
          )}

        <label className={'text-normal font-md flex item-center cursor-pointer dark:text-gray-200'}>
          <input
            onChange={inputHandler}
            value={'change_next_visit'}
            checked={inputs?.[label] === 'change_next_visit'}
            className={'ml-2 w-5 h-5'}
            type="radio"
            name={label}
          />
          تعویض در مراجعه بعد
        </label>
      </div>

      {showBrands && (
        <BrandsModal
          activeFilter={activeFilter}
          label={label}
          services={services}
          setServices={setServices}
          list={list}
          setShowBrands={setShowBrands}
          inputs={inputs}
          setInputs={setInputs}
        />
      )}
    </>
  )
}

export default memo(ServiceItemCheckbox)
